import { render } from "./CadastradoresSof.vue?vue&type=template&id=4cdeb604&scoped=true"
import script from "./CadastradoresSof.vue?vue&type=script&lang=js"
export * from "./CadastradoresSof.vue?vue&type=script&lang=js"

import "@siop/standard-libui/dist/css/bootstrap-4/siop.css?vue&type=style&index=0&id=4cdeb604&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdeb604"]])

export default __exports__